module.exports = __webpack_public_path__ + "img/excavator-grey.a9f1f2c3.svg";